import {
  isTableBorderHidden,
  setBorderSize,
  findNode,
} from '@udecode/plate';

export const getOnSelectTableBorderFactory = (
  editor,
  selectedCells,
) => (border) => () => {
  if (selectedCells) {
    selectedCells.forEach(cell => {
      const foundCell = findNode(editor, { match: (n) => n.id === cell.id });
      if (foundCell) {
        if (border === 'none') {
          setBorderSize(editor, 0, { at: foundCell[1], border: 'all' });
        } else if (border === 'outer') {
          setBorderSize(editor, 1, { at: foundCell[1], border: 'all' });
        }
      }
    });
    return;
  }
  if (border === 'none') {
    setBorderSize(editor, 0, { border: 'all' });
  } else if (border === 'outer') {
    setBorderSize(editor, 1, { border: 'all' });
  } else {
    const size = isTableBorderHidden(editor, border) ? 1 : 0;
    setBorderSize(editor, size, { border });
  }
};
